import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../../app/store/utils/baseQueryWithReauth';

export interface INotificationItem {
  id: number;
  templateCode: string;
  eventType: string;
  status: string;
  description?: string;
  createdAt: string;
  payload?: Record<string, unknown>;
}

export interface INotificationsListResponse {
  list: INotificationItem[];
  total: number;
  totalPages?: number;
}

export interface INotificationsListQuery {
  page?: number;
  limit?: number;
  search?: string;
  filterId?: string;
  order?: string;
  orderDirection?: 'ASC' | 'DESC';
}

export interface INotificationsCountResponse {
  count: number;
}

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Notifications', 'NotificationsCount'],
  endpoints: build => ({
    getNotificationsList: build.query<
      INotificationsListResponse,
      INotificationsListQuery
    >({
      query: params => ({
        url: '/system/notifications/list',
        method: 'GET',
        params,
      }),
      transformResponse: (response: { data: INotificationsListResponse }) =>
        response.data,
      providesTags: ['Notifications'],
    }),

    getNotificationsCount: build.query<INotificationsCountResponse, void>({
      query: () => ({
        url: '/notifications/count',
        method: 'GET',
      }),
      transformResponse: (response: { data: INotificationsCountResponse }) =>
        response.data,
      providesTags: ['NotificationsCount'],
    }),
  }),
});

export const {
  useGetNotificationsListQuery,
  useGetNotificationsCountQuery,
} = notificationsApi;
